var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testing-wizard"},[_c('McWizard',{attrs:{"items":_vm.computedItems,"activeKey":_vm.activeKey,"withNumber":_vm.withNumber}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }